import React from "react";
import { GetStaticProps } from "next";

import { Seo } from "@/components";
import { type NavigationQuery, useNavigationQuery } from "@/generated/graphql";
import { DesktopCategoriesNav, MobileCategoriesNav } from "@/features/category";

type NavigationSuccessType = NavigationQuery["Navigation"];

type Props = {
  categories: NavigationSuccessType["categories"];
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const { Navigation } = await useNavigationQuery.fetcher()();

  return {
    props: { categories: Navigation.categories },
    revalidate: 600, // Cache for 10 min
  };
};

function CategoryPage({ categories }: Props) {
  return (
    <>
      <Seo templateTitle="Categories" />

      <DesktopCategoriesNav categories={categories} />
      <MobileCategoriesNav categories={categories} />
    </>
  );
}

export default CategoryPage;
